<!-- phone-order-mode -->
@if (isUserAuthenticated && isPhoneOrderMode) {
  <div class="row">
    <div class="col mode-wrap p-0">
      <ul class="list-unstyled text-center color-white m-0">
        <li class="list-inline-item">
          <i class="fa fa-phone-square f-s-18 px-2"></i>
          <strong translate>Phone order mode enabled</strong>
        </li>
        <li class="list-inline-item px-3">
          <i>{{relevantUser?.full_name}}</i>
        </li>
        <li class="list-inline-item px-5 actions-wrap">
          <button mat-icon-button
            [matMenuTriggerFor]="menu"
            class="btn p-1">
            <i class="fa fa-angle-down p-0"></i>
            <i class="fa fa-gear f-s-16"></i>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item
              routerLink="/admin/manage_customers.php">
              <i class="sli-call-out m-2"></i>
              <span translate>Back To Manage Customers</span>
            </a>
            <button mat-menu-item
              (click)="phoneOrderLogout('/admin/manage_customers.php')">
              <i class="sli-call-out m-2"></i>
              <span translate>Logout Phone Order Mode</span>
            </button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </div>
}
<!-- end phone-order-mode -->
